
import {defineComponent, PropType} from 'vue'
import CategoryPicker from "@/components/picker/CategoryPicker.vue"
import StringPicker from "@/components/picker/StringPicker.vue"
import {LichenRecordField, LichenRecordFieldValue} from "@/config/config-lichen"
import Button from "primevue/button";
import InfoButton from "@/components/legend/InfoButton.vue";


export default defineComponent({
  name: "TaxonPicker",
  components: {StringPicker, CategoryPicker, Button, InfoButton},
  data() {
    return {
      hover: false,
      ifFlorAppReferenceWork: null,
      taxonId: null,
      suggestTaxon: false,
    }
  },
  props: {
    name: {type: String, required: true},
    value: {type: [] as PropType<LichenRecordField[]>, required: true},
    title: {type: String, required: true},
    required: {type: Boolean, default: false}
  },
  computed: {
    taxonid_api(): string {
      if(this.taxonFields[0].value !== null){
        return this.taxonFields[1].api + "?reference=" + this.taxonFields[0].value
      } else {
        return this.taxonFields[1].api + "?reference=" + this.taxonFields[0].defaultValue
      }
    },
    taxonFields(): LichenRecordField[] {
      return this.value.filter((fields: LichenRecordField) => !fields.name.startsWith('suggested'))
    },
    suggestedFields(): LichenRecordField[] {
      return this.value.filter((fields: LichenRecordField) => fields.name.startsWith('suggested'))
    }
  },
  methods: {
    select(value: { key: string, value: LichenRecordFieldValue }) {
      this.$emit('select', {key: this.name + '.' + value.key, value: value.value})
    },
  },
  watch: {
    suggestTaxon: {
      handler() {
        if (this.suggestTaxon) {
          this.taxonFields.forEach(field => this.select({key: field.name, value: field.value}))
        } else {
          this.suggestedFields.forEach(field => this.select({key: field.name, value: field.value}))
        }
      }
    }
  },
})
